import { render, staticRenderFns } from "./CsimSchemaCopyFormModal.vue?vue&type=template&id=72244928&scoped=true"
import script from "./CsimSchemaCopyFormModal.vue?vue&type=script&lang=js"
export * from "./CsimSchemaCopyFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72244928",
  null
  
)

export default component.exports